var exports = {
  "x": "gridColumnTemplate__lF16mF",
};

module.exports = exports;
